<template>
  <div class="login-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6">
          <div class="form-wrapper">
            <div class="login-logo">
              <img src="../assets/icons/metapic-logo-black.svg" alt="metapic logo" class="logo-brand" />
            </div>
            <form id="request" class="auth-form" method="post" @submit="request">
              <div v-if="errors" class="alert alert-warning alert-dismissible fade show" :class="{ show: errors }" role="alert">
                <strong>Error</strong> {{ errors }}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div v-if="success" class="alert alert-success alert-dismissible fade show" :class="{ show: success }" role="alert">
                <strong>Success!</strong> {{ success }}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <h1 class="mb-4">Send us your request</h1>
              <div class="mb-3">
                <label for="InputEmail">Email address</label>
                <input
                  id="InputEmail"
                  v-model="email"
                  type="email"
                  name="email"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Enter email"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="InputCountry">Country</label>
                <input
                  id="InputCountry"
                  v-model="country"
                  type="text"
                  name="country"
                  class="form-control"
                  placeholder="Country"
                  required
                  @blur="emptyErrors"
                />
              </div>
              <div class="mb-3">
                <label for="website">Your website</label>
                <input id="website" v-model="website" type="text" name="website" class="form-control" placeholder="Website" required />
              </div>

              <v-button class="btn btn-primary w-100 mt-4 mb-3" :loading="loading"> Send request </v-button>
              Already a member?
              <router-link :to="{ name: 'login' }">Sign in</router-link>
            </form>
          </div>
        </div>

        <div class="hide-mobile col-lg-6 vh-100 metapic-image"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import axios from 'axios'

export default {
  name: 'Home',
  middleware: 'guest',
  data: function () {
    return {
      loading: false,
      errors: '',
      success: '',
      email: '',
      website: '',
      country: '',
    }
  },
  methods: {
    request: function (e) {
      e.preventDefault()
      this.loading = true

      const credentials = {
        email: this.email,
        country: this.country,
        website: this.website,
      }
      axios({
        // @ts-expect-error todo fix me
        url: window.apiUrl + '/stores/request',
        data: credentials,
        method: 'POST',
      })
        .then(() => {
          // // Redirect home.
          // if(response.status == 'success') {
          this.success = 'Your request has been sent'
          // }
          this.loading = false
        })
        .catch((error_message) => {
          this.errors = error_message.response.data.error_message
          this.loading = false
        })
    },
    emptyErrors() {
      this.errors = ''
    },
  },
}
</script>

<style scoped lang="scss">
.login-page {
  height: 100vh;
}
.login-logo {
  position: absolute;
  top: 0;
}
.logo-brand {
  width: 120px;
  margin: 1rem;
}
.form-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.hide-mobile {
  @media screen and (max-width: 992px) {
    display: none !important;
  }
}
.metapic-image {
  background: url('../assets/metapic.jpg') 0 0 / cover no-repeat;
}
</style>
